import VgtSetMeterRequestBase from './base/VgtSetMeterRequestBase';

/**
 * @class VgtSetMeterRequest
 * @extends VgtSetMeterRequestBase
 */
class VgtSetMeterRequest extends VgtSetMeterRequestBase {

}

export default VgtSetMeterRequest;
